import { MultipleSelect } from '@iqueue/ui-kit'
import { useCallback, useState, useEffect } from 'react'
import useTranslate, { t } from '../../hooks/useTranslate'
import HelpersPresenter from '../../api/helpersPresenter'

export default function PickTables({
  name = 'table',
  value,
  onChange,
  hidden,
  ...props
}) {
  const [tables, setTables] = useState([])
  const locale = useTranslate()

  const render = useCallback((id) => {
    return {
      id: id,
      title: t(`settingsPage.tables.${ id }`) || 'GGGGG',
    }
  }, [locale])

  const fetchData = useCallback(() => {
    return HelpersPresenter.get('database/tables').then(setTables)
  }, [])

  const handleSelectChange = useCallback((id) => {
    onChange(id)
  }, [])

  useEffect(() => {
    fetchData().catch(err => console.error(err))
  }, [])

  return <MultipleSelect
    name={ name }
    entries={ tables }
    render={ (v) => {
      return { id: v, title: v }
    } }
    value={ value }
    allowSearch
    onChange={ handleSelectChange }
    { ...props }
  />
}
